export enum InteractionType {
    SingleTouch,
    DoubleTouch,
    TouchUp,
    TouchDown,
    Move
}
